import { CloseIconModal } from "../../../../assets/fonts/icon/icons";
import { Modal, Typography, Button, Divider } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { complexDigitToman, convertToJalaliWithTime, formatTime } from "../../../../tools/tools";

const Holder_Button = styled.div`
  display: flex;
  .btn-normal {
    width: 100%;
    height: 3.125rem;
  }
`;
const Policy = styled.div`
  padding: 1rem;
  ul {
    li {
      padding-bottom: 0.5rem;
      font-size: 0.9rem;
      text-align: justify;
    }
  }
`;

const AcceptanceNote = styled.div`
  margin-top: 1rem;
  border-radius: 0.5rem;
  padding: 0.75rem 0.875rem;
  background: #fff5f2;
  color: #7f2119;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.9;
  text-align: right;
`;

const AuctionNumber = styled.div`
  margin: -0.75rem auto 1.25rem;
  border: 1px solid #eee;
  border-radius: 0.625rem;
  padding: 0.75rem 1rem;
  background: #fafafa;
  text-align: center;
  span {
    display: block;
    margin-bottom: 0.25rem;
    color: #777;
    font-size: 0.75rem;
  }
  strong {
    display: block;
    color: #222;
    font-size: 1.2rem;
    letter-spacing: 0.04em;
  }
`;

const PolicyModal = ({ open, callback }) => {
  const { Paragraph, Text, Title } = Typography;
  const MyModal = styled(Modal)``;
  const content_modal = styled.div``;

  const [isOpen, setIsOpen] = useState();

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleCancel = () => {
    setIsOpen(false);
    callback();
  };
  return (
    <MyModal onCancel={handleCancel} width={"48.875rem"} open={isOpen} closeIcon={<CloseIconModal />} footer={<></>}>
      <content_modal>
        <Paragraph>
          <Paragraph>
            <Title style={{ textAlign: "center" }} level={4}>
              قوانین و مقررات
            </Title>
          </Paragraph>
          <Paragraph>
            <Text>
              <Policy>
                <ul>
                  <li>ورود اطلاعات هویتیِ درخواستی به‌صورت صحیح و مطابق کارت ملی الزامی است. </li>
                  <li>
                    هم اکنون براساس قوانین موجود، هر مشترک می تواند حداکثر 10عدد سیم کارت در شبکه تلفن همراه کشور به نام خود ثبت نام کند، لذا
                    شرکت‌کننده‌ها در مزایده بایستی به این نکته توجه نمایند در صورتی‌که سیم‌کارت‌های بنامِ ایشان به سقف مجاز رسیده باشد، حتی زمانی که
                    نفر اول مزایده باشد، پس از بررسی در سیستم، از لیست برنده‌ها حذف خواهد ‌شد.
                  </li>
                  <li>
                    در صورتی که شرکت‌کننده‌ای در چند مزایده به طور همزمان برنده شود، به نحوی که مجموع تعداد سیم‌کارت‌های سابقِ بنامِ وی با
                    سیم‌کارت‌هایی که حق تقدم در مزایده آنها را پیدا نموده از سقف مذکور (10 عدد) تجاوز نماید، با حفظ تقدم مزایده‌های شرکت نموده،
                    مزایده‌های بعدی وی ابطال خواهد‌ شد. برای رفع این محدودیت می‌بایست قبل از برنده‌شدن در مزایده، به تعداد مورد نظر، سیم‌کارت‌های خود
                    را از مالکیت خارج کند.
                  </li>
                  <li>امکان واگذاری سیم‌کارت به افراد کمتر از 18 سال تمام وجود ندارد.</li>
                  <li> فقط اشخاص حقیقی امکان ثبت‌نام و شرکت در مزایده را دارند.</li>
                  <li>شرکت‌کنندگان می‌بایست نسبت به افزایش اعتبار کافی جهت ودیعه گذاری برای شرکت در حراج شماره‌های مورد نظر اقدام نمایند. </li>
                  <li>شرکت‌کنندگان می‌بایست در مدت زمان فعال بودن مزایده نسبت به ارایه قیمت پیشنهادی اقدام نمایند.</li>
                  <li>
                    با توجه به این که در این طرح، سیم کارت از طریق مزایده واگذار می گردد، امکان ثبت قیمت یکسان بطور همزمان، برای دو مشترک وجود ندارد.
                  </li>
                  <li> چنانچه طی ۴ ساعت پایانی زمان مزایده پیشنهاد جدیدی ثبت گردد، زمان پایان مزایده 8 ساعت نسبت به زمان قبلی افزایش خواهد یافت.</li>
                  <li> کلیه خریدها و مزایده‌های اعلام‌شده، مشمول هزینه‌های قانونی اعم از 10%ماليات هنگام پرداخت توسط سیستم محاسبه‌شده‌است. </li>
                  <li> در هر مرحله شرکت در مزایده، برای هر شماره آپتل، فقط یک نفر براساس قیمت پیشنهادی به عنوان برنده انتخاب و معرفی می‌گردد.</li>
                  <li>
                    بعد از اتمام هر مزایده، شخصی که بالاترین پیشنهاد را ثبت نموده به عنوان برنده مزایده انتخاب خواهد شد و تا 48 ساعت فرصت دارد نسبت به
                    پرداخت مابه تفاوت قیمت نهایی و ودیعه اقدام نماید. بدیهی است در صورت عدم پرداخت در بازه زمانی اعلام شده، مبلغ ودیعه ضبط خواهد شد.
                  </li>
                  <li> آپتل در پذیرش یا رد کلیه پیشنهادات قیمتی و شماره مختار و مجاز است.</li>
                  <li>
                    در صورت تشخیص تبانی بین دو یا چند نفر از شرکت‌کنندگان در مزایده، آپتل ضمن باطل‌کردن آن مرحله مزایده و ضبط مبلغ واریز‌شده، از طریق
                    مراجع قضایی برعلیه نفرات متخلّف اقدام قانونی صورت خواهد‌پذیرفت.
                  </li>
                  <li> تمامی قوانین مربوط به سیم کارت های آپتل، شامل سیم کارت های واگذار شده در مزایده شماره های رند نیز می شود.</li>
                  <li> آپتل هیچ‌گونه مسئوليتی در خصوص عدم توجه برنده بر اهمیت حفظ و نگهداری حساب کاربری نخواهد‌داشت. </li>
                  <li>
                    از آنجا که در صورت برنده‌شدن و طی مراحل قانونی، سیم‌کارت از طریق پست به نشانی و مشخصات ثبت ‌شده توسط شرکت کننده، ارسال خواهد‌شد،
                    ایشان موظف به ورود اطلاعات آدرس به صورت صحیح و کامل در هنگام ثبت‌نام می باشند. در صورت بروز هرگونه مشکل به علت نادرست بودن این
                    اطلاعات، آپتل هیچگونه مسئولیتی در قبال برگشت خوردن سیم‌کارت بر عهده نخواهد‌داشت.
                  </li>
                  <li> نظارت بر حسن اجرای این آیین‌نامه به عهده" آپتل "خواهد‌بود. شرکت‌کنندگان پس از تایید، حق هیچ گونه اعتراضی به آن ندارند.</li>
                  <li>
                    مطالعه‌ی "شرایط و قوانین"شرکت در مزایده توسط شرکت کننده الزامی است و شرکت در مزایده به منزله پذیرش شرایط، ضوابط و قوانین حاکم بر
                    آن تلقی می گردد.
                  </li>
                  <li>
                    شرکت‌کننده ضمن قبول شرایط و ضوابط شرکت در مزایده موضوع سند حاضر، حق هرگونه ادعا و اعتراض در خصوص مفاد آن را از خود سلب و ساقط
                    نموده‌است.
                  </li>
                  <li>
                    شرکت در مزایده شماره تلفن‌های رند بر مبنای پذیرش قوانین و آیین‌نامه‌های موجود در مورد اشتراك تلفن همراه، تجارت الکترونیک و با
                    رعایت کامل تمام قوانین جمهوری اسلامی ایران صورت می‌پذیرد.
                  </li>
                </ul>
              </Policy>
            </Text>
          </Paragraph>
        </Paragraph>
      </content_modal>
    </MyModal>
  );
};

export default PolicyModal;

const AlertTenderModal = ({ open, price = 0, auctionNumber = "", callback, showStartAuctionAcceptance = false }) => {
  const { Paragraph, Text, Title } = Typography;
  const Content_Modal = styled.div`
    padding: 1rem 0;
  `;

  const [isOpen, setIsOpen] = useState();
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleCancel = (state = false) => {
    setIsOpen(false);
    callback(state);
  };
  return (
    <>
      <Modal
        onCancel={() => handleCancel(false)}
        width={"28.5rem"}
        centered
        open={isOpen}
        closeIcon={<></>}
        footer={
          <>
            <Divider />
            <Holder_Button className="holder-button">
              <Button onClick={() => handleCancel(false)}>بازگشت</Button>
              <Button onClick={() => handleCancel(true)} className="btn-aptel">
                تایید و پرداخت
              </Button>
            </Holder_Button>
          </>
        }
      >
        <Content_Modal>
          <Paragraph>
            <Paragraph style={{ marginBlockEnd: "2rem" }}>
              <Title style={{ textAlign: "center" }} level={4}>
                پرداخت ودیعه
              </Title>
            </Paragraph>
            {auctionNumber && (
              <AuctionNumber>
                <span>شماره انتخاب‌شده برای شروع مزایده</span>
                <strong dir="ltr">{auctionNumber}</strong>
              </AuctionNumber>
            )}
            <Paragraph style={{ fontSize: "1rem", textAlign: "justify" }}>
              <Text>
                برای شرکت در این مزایده <Text strong>مبلغ {complexDigitToman(price)} تومان</Text> به عنوان ودیعه از اعتبار شما برداشت خواهد شد. در نظر
                داشته باشید که مبلغ ودیعه تا پایان مزایده قابل برداشت نخواهد بود.
              </Text>
            </Paragraph>
            {showStartAuctionAcceptance && (
              <AcceptanceNote>
                با پرداخت و شروع مزایده این شماره تمام قوانین و مقررات شرکت در مزایده آنلاین آپتل را قبول دارم.
              </AcceptanceNote>
            )}
          </Paragraph>
        </Content_Modal>
      </Modal>
    </>
  );
};

export { AlertTenderModal };

const PreFactor = ({ open, factor = {}, callback }) => {
  const PrefactorClass = styled.div`
    padding: 1rem 1rem 0 1rem;
    h3 {
      color: #4d4d4d;
      text-align: center;
      font-size: 1.1rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin: 0;
      padding: 0;
    }
    .holder_list {
      padding: 1rem 0 0 0;
      margin-top: 1rem;
      ul {
        margin: 0;
        padding: 0;
        li {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          padding-bottom: 1rem;
          border-bottom: solid 1px rgba(217, 217, 217, 0.4);
          &:last-child {
            border-bottom: none;
          }
          .label {
            flex: auto;
          }
          .value {
            text-align: left;
          }
        }
      }
    }
  `;

  const [isOpen, setIsOpen] = useState();
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleCancel = (state = false) => {
    setIsOpen(false);
    callback(state);
  };
  return (
    <>
      <Modal
        onCancel={() => handleCancel(false)}
        width={"28.5rem"}
        centered
        open={isOpen}
        closeIcon={<></>}
        footer={
          <>
            <Divider />
            <Holder_Button className="holder-button">
              <Button onClick={() => handleCancel(false)}>بازگشت</Button>
              <Button onClick={() => handleCancel(true)} className="btn-aptel">
                تایید و پرداخت
              </Button>
            </Holder_Button>
          </>
        }
      >
        <PrefactorClass>
          <h3>بررسی و تایید نهایی</h3>
          <div className="holder_list">
            <ul>
              <li>
                <div className="label">شماره:</div>
                <div className="value">
                  <span dir="ltr">{factor?.auctionTitle}</span>
                </div>
              </li>
              <li>
                <div className="label">بسته هدیه:</div>
                <div className="value">{factor?.bundle?.bundleName}</div>
              </li>
              {/* <li>
                <div className="label">نوع سیمکارت:</div>
                <div className="value">دايمی</div>
              </li> */}
              <li>
                <div className="label">مبلغ ودیعه:</div>
                <div className="value">
                  <span dir="ltr">{complexDigitToman(factor?.tenderDeposit)}</span> تومان
                </div>
              </li>
              <li>
                <div className="label">مبلغ پیشنهادی شما:</div>
                <div className="value">
                  <span dir="ltr">{complexDigitToman(factor?.bidAmount)}</span> تومان
                </div>
              </li>
            </ul>
          </div>
        </PrefactorClass>
      </Modal>
    </>
  );
};

export { PreFactor };

const ModalFactor = ({ open, factor = {}, callback }) => {
  const PrefactorClass = styled.div`
    padding: 1rem 1rem 0 1rem;
    .holder-icon {
      text-align: center;
      h3 {
        color: #4d4d4d;
        text-align: center;
        font-size: 1.1rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
        padding: 0;
      }
    }

    .holder_list {
      padding: 1rem 0 0 0;
      margin-top: 1rem;
      ul {
        margin: 0;
        padding: 0;
        li {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          padding-bottom: 1rem;
          border-bottom: solid 1px rgba(217, 217, 217, 0.4);
          &:last-child {
            border-bottom: none;
          }
          .label {
            flex: auto;
          }
          .value {
            text-align: left;
          }
        }
      }
    }
  `;

  const [isOpen, setIsOpen] = useState();
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleCancel = (state = false) => {
    setIsOpen(false);
    callback(state);
  };
  return (
    <>
      <Modal
        onCancel={() => handleCancel(false)}
        width={"28.5rem"}
        centered
        open={isOpen}
        closeIcon={<></>}
        footer={
          <>
            <Divider />
            <Holder_Button className="holder-button">
              <Button onClick={() => handleCancel(false)}>بازگشت</Button>
            </Holder_Button>
          </>
        }
      >
        <PrefactorClass>
          <div className="holder-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82" fill="none">
              <circle cx="41" cy="41" r="41" fill="#37B399" />
              <path
                d="M57.8873 24.6016L33.9909 48.8479L25.2837 40.0132L19.9141 45.4615L33.9909 59.7444L63.2569 30.0498L57.8873 24.6016Z"
                fill="white"
              />
            </svg>
            <h3>عملیات موفق</h3>
          </div>
          <div className="holder_list">
            <ul>
              <li>
                <div className="label">تاریخ و ساعت</div>
                <div className="value">
                  <span dir="ltr">
                    {convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
                  </span>
                </div>
              </li>
              <li>
                <div className="label">شماره:</div>
                <div className="value">
                  <span dir="ltr">{factor?.auctionTitle}</span>
                </div>
              </li>
              <li>
                <div className="label">بسته هدیه:</div>
                <div className="value">{factor?.bundle?.bundleName}</div>
              </li>
              {/* <li>
                <div className="label">نوع سیمکارت:</div>
                <div className="value">دايمی</div>
              </li> */}
              <li>
                <div className="label">مبلغ ودیعه:</div>
                <div className="value">
                  <span dir="ltr">{complexDigitToman(factor?.tenderDeposit)}</span> تومان
                </div>
              </li>
              <li>
                <div className="label">مبلغ پیشنهادی شما:</div>
                <div className="value">
                  <span dir="ltr">{complexDigitToman(factor?.bidAmount)}</span> تومان
                </div>
              </li>
            </ul>
          </div>
        </PrefactorClass>
      </Modal>
    </>
  );
};

export { ModalFactor };

const ModalFactorWithdraw = ({ open, factor = {}, callback }) => {
  const PrefactorClass = styled.div`
    padding: 1rem 1rem 0 1rem;
    .holder-icon {
      text-align: center;
      h3 {
        color: #4d4d4d;
        text-align: center;
        font-size: 1.1rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
        padding: 0;
      }
    }

    .holder_list {
      padding: 1rem 0 0 0;
      margin-top: 1rem;
      ul {
        margin: 0;
        padding: 0;
        li {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
          padding-bottom: 1rem;
          border-bottom: solid 1px rgba(217, 217, 217, 0.4);
          &:last-child {
            border-bottom: none;
          }
          .label {
            flex: auto;
          }
          .value {
            text-align: left;
          }
        }
      }
    }
  `;

  const [isOpen, setIsOpen] = useState();
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleCancel = (state = false) => {
    setIsOpen(false);
    callback(state);
  };
  return (
    <>
      <Modal
        onCancel={() => handleCancel(false)}
        width={"28.5rem"}
        centered
        open={isOpen}
        closeIcon={<></>}
        footer={
          <>
            <Divider />
            <Holder_Button className="holder-button">
              <Button onClick={() => handleCancel(false)}>بازگشت</Button>
            </Holder_Button>
          </>
        }
      >
        <PrefactorClass>
          <div className="holder-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82" fill="none">
              <circle cx="41" cy="41" r="41" fill="#37B399" />
              <path
                d="M57.8873 24.6016L33.9909 48.8479L25.2837 40.0132L19.9141 45.4615L33.9909 59.7444L63.2569 30.0498L57.8873 24.6016Z"
                fill="white"
              />
            </svg>
            <h3>عملیات موفق</h3>
          </div>
          <div className="holder_list">
            <ul>
              <li>
                <div className="label">تاریخ و ساعت</div>
                <div className="value">
                  <span dir="ltr">
                    {convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
                  </span>
                </div>
              </li>
              <li>
                <div className="label">مبلغ:</div>
                <div className="value">
                  <span dir="ltr">{complexDigitToman(factor?.amount)}</span>
                </div>
              </li>
              <li>
                <div className="label">کدپیگیری:</div>
                <div className="value">{factor?.followupcode}</div>
              </li>
            </ul>
          </div>
        </PrefactorClass>
      </Modal>
    </>
  );
};

export { ModalFactorWithdraw };
